export const CREATE_MHP_TREATMENT_CASE = "CREATE_MHP_TREATMENT_CASE";

export const LOAD_MHP_TREATMENT_CONSULTATION = "LOAD_MHP_TREATMENT_CONSULTATION";
export const SAVE_MHP_TREATMENT_CONSULTATION = "SAVE_MHP_TREATMENT_CONSULTATION";
export const SUBMIT_MHP_TREATMENT_CONSULTATION = "SUBMIT_MHP_TREATMENT_CONSULTATION";

export const LOAD_MHP_TREATMENT_REPORT = "LOAD_MHP_TREATMENT_REPORT";
export const LOAD_MHP_TREATMENT_REPORT_PREVIEW = "LOAD_MHP_TREATMENT_REPORT_PREVIEW";
export const SAVE_MHP_TREATMENT_REPORT = "SAVE_MHP_TREATMENT_REPORT";
export const SUBMIT_MHP_TREATMENT_REPORT = "SUBMIT_MHP_TREATMENT_REPORT";
export const SUBMIT_MHP_TREATMENT_REPORT_SUCCESS = "SUBMIT_MHP_TREATMENT_REPORT_SUCCESS";

export const APPROVE_MHP_TREATMENT_REPORT = "APPROVE_MHP_TREATMENT_REPORT";
export const APPROVE_MHP_TREATMENT_REPORT_SUCCESS = "APPROVE_MHP_TREATMENT_REPORT_SUCCESS";
export const REQUEST_CHANGES_MHP_TREATMENT_REPORT = "REQUEST_CHANGES_MHP_TREATMENT_REPORT";
export const REQUEST_CHANGES_MHP_TREATMENT_REPORT_SUCCESS = "REQUEST_CHANGES_MHP_TREATMENT_REPORT_SUCCESS";
export const REJECT_MHP_TREATMENT_REPORT = "REJECT_MHP_TREATMENT_REPORT";
export const REJECT_MHP_TREATMENT_REPORT_SUCCESS = "REJECT_MHP_TREATMENT_REPORT_SUCCESS";
